import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';

import YellowExclamation from '../yellow_exclamation';

import Html from '../../modules/html';

interface EmergencyBannerProps {
  dispatch: ({ type }: { type: string, [key: string]: any}) => void;
  window: Window,
  emergencyBanner: { show?: boolean, html?: string; }
  test?: boolean;
} ;

const styles = {
  button: RX.Styles.createButtonStyle({
    padding: 0,
    position: 'absolute',
    right: 16,
    top: 16,
  }),
  close: RX.Styles.createTextStyle({
    fontSize: 20,
    fontWeight: 'bold',
  }),
  exclamationPoint: RX.Styles.createTextStyle({
    color: colors.alert,
    fontSize: 100,
    fontWeight: '500',
  }),
  popup: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: colors.alert,
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 300,
    minWidth: 300,
    padding: 16,
  }),
  wrapper: RX.Styles.createViewStyle({
    alignItems: 'center',
    backgroundColor: 'rgba(204, 204, 204, .6)',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    top: 0,
  }),
};

export class EmergencyBanner extends RX.Component<EmergencyBannerProps, RX.CommonProps & EmergencyBannerProps> {
  constructor(props: EmergencyBannerProps) {
    super(props);
  }

  public render() {
    const { window: { height, width }, emergencyBanner: { show, html }, dispatch, test } = this.props;
    return (
      show ? <RX.View style={[styles.wrapper, { width, height }]}>
        <RX.View style={[styles.popup, { maxWidth: width }]}>
          <RX.View style={{ marginRight: 16 }}>
            {!test && <YellowExclamation />}
          </RX.View>
          <RX.View style={{ maxWidth: (width - 32) / 2}}>
            {!test ? <Html { ...{ html }} /> : html }
          </RX.View>
          <RX.Button
            style={styles.button}
            onPress={() => dispatch({ type: 'CLOSE_EMERGENCY_BANNER' })}
          >
            <RX.Text style={styles.close}>X</RX.Text>
          </RX.Button>
        </RX.View>
      </RX.View> : null
    );
  }
}

export default connect(mapStateToProps)(EmergencyBanner);



// WEBPACK FOOTER //
// ./src/components/emergency_banner/index.tsx